import React from 'react';

import AiChatIcon from '@atlaskit/icon/core/ai-chat';
import type { NudgeRecommendationDetails } from '@atlassian/convo-ai-api';
import { type ChatAction, HandleActionType } from '@atlassian/rovo-conversation-actions/types';

import { CONVO_STARTER_ID } from '../constants';

export const enrichConversationStarterNudge = (
	recommendation: NudgeRecommendationDetails,
): ChatAction | undefined => {
	const label = recommendation.cta.cta_label;
	if (!label) {
		return undefined;
	}

	return {
		id: CONVO_STARTER_ID,
		title: label,
		icon: () => <AiChatIcon label="" />,
		type: 'convo-starter-action',
		staticPrompt: label,
		starterType: 'static',
		handleType: HandleActionType.Chat,
		nudgeContext: {
			id: CONVO_STARTER_ID,
			suppressionKey: recommendation.context?.context_id ?? undefined,
		},
	};
};
